import { BrowserRouter as Router, Route } from "react-router-dom";
import Cursor from "./components/Cursor";
import NavBar from "./components/NavBar";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Project from "./pages/Project";

function App() {
  return (
    <Router>
      <NavBar />

      <Route path="/" exact component={Home} />
      <Project />
      <About />
      <Contact />
      <Cursor />
    </Router>
  );
}

export default App;
